'use strict';

export class RefreshWorklistDetailsDialogModel {
  constructor(refresh) {
    this.refresh = refresh;
  }

  init(modal, scope, modalService) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
  }

  async refreshCall(){
    this.refresh();
    this.cancelled = true;
    this.modalInstance.remove();
  }

  async closeWindow() {    
    this.cancelled = true;
    this.modalInstance.remove();
  };
}



// WEBPACK FOOTER //
// ./src/scripts/models/refreshWorklistDetails.js